/**
 * Funzioni API per i privilegi RBAC per ruolo (Admin — product-service).
 *
 * Endpoint:
 *   GET /api/products/admin/role-permissions  → RolePermissionsMap
 *   PUT /api/products/admin/role-permissions  → RolePermissionsMap (solo SYSTEM_CONFIGURATION)
 *   GET /api/products/admin/permissions       → PermissionsCatalog (Task 6)
 */

import { createServiceClient } from '../../api/client.js';
import type { RolePermissionsMap, PermissionsCatalog } from './role-permissions-types.js';

/** Client parzialmente applicato per il product-service. */
const productApi = createServiceClient('product');

/**
 * Recupera il catalogo dei privilegi assegnabili (canonici `Resource.Operation` + legacy DT),
 * per costruire le righe della matrice RBAC raggruppate per risorsa (Task 6).
 * GET /api/products/admin/permissions
 */
export function fetchPermissionsCatalog(): Promise<PermissionsCatalog> {
  return productApi<PermissionsCatalog>('/admin/permissions');
}

/**
 * Recupera la mappa corrente ruolo → privilegi RBAC.
 * GET /api/products/admin/role-permissions
 */
export function fetchRolePermissions(): Promise<RolePermissionsMap> {
  // NB: createServiceClient('product') prefissa già SERVICE_URLS.product (/api/products):
  // il path qui è relativo, altrimenti si ottiene /api/products/api/products/... → 404.
  return productApi<RolePermissionsMap>('/admin/role-permissions');
}

/**
 * Aggiorna la mappa ruolo → privilegi RBAC.
 * PUT /api/products/admin/role-permissions
 */
export function updateRolePermissions(map: RolePermissionsMap): Promise<RolePermissionsMap> {
  return productApi<RolePermissionsMap>('/admin/role-permissions', {
    method: 'PUT',
    body: map,
  });
}

/**
 * Crea un ruolo custom.
 * POST /api/products/admin/roles
 */
export function createRole(
  name: string,
  basedOn?: string[],
): Promise<{ name: string; isBuiltin: boolean }> {
  return productApi<{ name: string; isBuiltin: boolean }>('/admin/roles', {
    method: 'POST',
    body: basedOn ? { name, basedOn } : { name },
  });
}
